import { Box, Text } from "pcln-design-system";
import styled_components from "styled-components";
const ListingCardWrapper = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "HotlListingCard.styles__ListingCardWrapper"
})([
    "background-color:#fff;cursor:pointer;"
]);
const Img = /*#__PURE__*/ styled_components.img.withConfig({
    displayName: "HotlListingCard.styles__Img"
})([
    "object-fit:cover;height:153px;width:100%;border-top-left-radius:16px;border-top-right-radius:16px;"
]);
const PriceCurrency = /*#__PURE__*/ styled_components(Text.span).withConfig({
    displayName: "HotlListingCard.styles__PriceCurrency"
})([
    "vertical-align:super;position:relative;top:-2px;margin-right:2px;"
]);
const PriceCurrencyStrikeThrough = /*#__PURE__*/ styled_components(PriceCurrency).withConfig({
    displayName: "HotlListingCard.styles__PriceCurrencyStrikeThrough"
})([
    "top:1px;"
]);
const TextStrikeThrough = /*#__PURE__*/ styled_components(Text).withConfig({
    displayName: "HotlListingCard.styles__TextStrikeThrough"
})([
    "& ::before{content:'';width:40%;position:absolute;right:0px;top:14px;border-bottom:2px solid rgb(79,111,143);transform:skewY(-13deg);}"
]);
export { Img, ListingCardWrapper, PriceCurrency, PriceCurrencyStrikeThrough, TextStrikeThrough };
